import React from 'react';
import './Expert.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { BsFillCheckCircleFill } from "react-icons/bs";
import expertImg from '../../assets/expert.png';

const Expert = () => {
    return (
        <section className='expert-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-text">
                            <SectionTitle 
                                subTitle="EXPERTS EM ODONTOLOGIA"
                                title="Odontologia de excelência, pelos melhores dentistas de Luanda."
                                description="Nossa equipe de dentistas altamente qualificados combina experiência, tecnologia avançada e atendimento personalizado para garantir tratamentos seguros e eficazes."
                            />

                            <ul>
                                <li>
                                    <BsFillCheckCircleFill />
                                    Equipe odontológica de alta qualidade
                                </li>
                                <li>
                                    <BsFillCheckCircleFill />
                                    Serviços dentários de última geração
                                </li>
                                <li>
                                    <BsFillCheckCircleFill />
                                    Descontos em todos os tratamentos dentários
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-img">
                            <img src={expertImg} alt="expert" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expert;